import { StyledFlex } from '@dreryk/react-components';

import { ArchiveIcon } from './ArchiveIcon';
import { EntitlementStatementPrintIcon } from './EntitlementStatementPrintIcon';

export type ActionsCellProps = {
   readonly id: number;
   readonly onArchive: VoidFunction;
};

export const ActionsCell = (props: ActionsCellProps): JSX.Element => {
   return (
      <StyledFlex justifyContent={'flex-end'} flex={'1'}>
         <EntitlementStatementPrintIcon entitlementStatementId={props.id} />
         <ArchiveIcon id={props.id} onArchive={props.onArchive} />
      </StyledFlex>
   );
};
